import { createConfigService } from '@srm/core/config';
import type { IConfig } from '../models/IConfig';

/** Конфиг приложения (`config.json` рядом с index.html): читается до монтирования, дальше — `ConfigService.get()`. */
export const ConfigService = createConfigService<IConfig>({ basePath: import.meta.env.VITE_BASE_PATH as string });

await ConfigService.initAsync();
